const TOOLBAR_CLASS_NAME = 'fingo-toolbar';
const CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME = 'credentials_update_bottom_bar';
export {
  TOOLBAR_CLASS_NAME,
  CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME,
};
